export const styles = {
  wrapper: 'tw-relative',
  menu: 'tw-absolute tw-right-0 tw-top-full tw-mt-1 tw-z-50 tw-min-w-[160px] tw-rounded tw-border tw-border-neutral-200 tw-bg-white tw-shadow-lg tw-py-1',
  item: 'tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-text-neutral-700 hover:tw-bg-neutral-100 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-left tw-whitespace-nowrap',
  itemDanger: 'tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-text-red-600 hover:tw-bg-red-50 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-left tw-whitespace-nowrap',
  itemDisabled: 'tw-opacity-50 tw-cursor-not-allowed hover:tw-bg-transparent',
  itemIcon: 'tw-w-4 tw-h-4 tw-flex-shrink-0',
};
